import { cn, Col, InferenceIcon } from "@kuzco/web/ui";

type EmptyStateLayoutProps = {
  /** Path under /public/ for the centered illustration. */
  imageSrc: string;
  title: string;
  description: React.ReactNode;
  actions: React.ReactNode;
  /**
   * If true, omits the top-left Inference logo header. Use this when rendering
   * inside the dashboard shell (which already has its own logo/chrome).
   */
  hideHeader?: boolean;
};

export function EmptyStateLayout({
  imageSrc,
  title,
  description,
  actions,
  hideHeader = false,
}: EmptyStateLayoutProps) {
  return (
    <section
      className={cn(
        "relative flex w-full flex-col bg-background",
        hideHeader ? "h-full flex-1" : "min-h-svh",
      )}
    >
      {!hideHeader && (
        <header className="px-6 py-6 md:px-10 md:py-8">
          <InferenceIcon height={24} width={140} />
        </header>
      )}

      <Col
        className={cn(
          "relative z-10 flex-1 items-center justify-center gap-8 px-6 text-center",
          !hideHeader && "pb-12",
        )}
      >
        <img src={imageSrc} alt="" className="block h-48 w-auto" />

        <h1
          className={`
            max-w-lg font-serif text-5xl tracking-tight text-foreground
            lg:text-6xl
          `}
        >
          {title}
        </h1>

        <p
          className={`
            max-w-md text-lg font-light leading-relaxed text-muted-foreground
          `}
        >
          {description}
        </p>

        {actions}
      </Col>
    </section>
  );
}
